var FcDateInputModule = /** @class */ (function () {
    function FcDateInputModule() {
    }
    return FcDateInputModule;
}());
export { FcDateInputModule };
